import React from 'react'
import PropTypes from 'prop-types'
import { BaseForm as Form } from 'component/base'

export const FurikomiTaishoKamoku = props => {
  return (
    <Form.Dropdown.WithAPI
      url='/api/staff/master/kumiai_yakushoku'
      keyName='id'
      valueName='id'
      textName='name'
      {...props}
    />
  )
}

FurikomiTaishoKamoku.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
}

FurikomiTaishoKamoku.defaultProps = {
  name: 'furikomi_taisho_kamoku_cd_list',
  label: '振込対象科目',
  value: undefined,
}
